export function observableArrayHasValueFilter(obsArr: Array<any>): boolean {
  let dataLoaded = true;
  obsArr.map((data) => {
    if (data === null) {
      dataLoaded = false;
    }
  });
  return dataLoaded;
}
